export function renderTabPanelId(value) {
    return `rtk-query-monitor-tab-panel-${value}`;
}
export function renderTabPanelButtonId(value) {
    return renderTabPanelId(value) + '-button';
}
